import { render, staticRenderFns } from "./AboutTwo.vue?vue&type=template&id=eb2369d4"
import script from "./AboutTwo.vue?vue&type=script&lang=js"
export * from "./AboutTwo.vue?vue&type=script&lang=js"
import style0 from "./AboutTwo.vue?vue&type=style&index=0&id=eb2369d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports